import { render, staticRenderFns } from "./userview.vue?vue&type=template&id=6c025717&scoped=true"
import script from "./userview.vue?vue&type=script&lang=js"
export * from "./userview.vue?vue&type=script&lang=js"
import style0 from "./userview.vue?vue&type=style&index=0&id=6c025717&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c025717",
  null
  
)

export default component.exports